import {useFormik} from 'formik'
import {ILink, ILinkFormValues, initLinkFormValues} from '../_modal'
import {KTIcon} from '../../../../../_metronic/helpers'
import {BASE_URL} from '../../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import toast from 'react-hot-toast'
import {useEffect} from 'react'
import {handleAxiosError} from '../../../../utils/helperFunction/_helper'

type Props = {
  selectedLink: ILink | undefined
  onResetSelect: () => void
}

const CREATE_LINK_URL = `${BASE_URL}/api/protect/createLink`
const UPDATE_LINK_URL = `${BASE_URL}/api/protect/updateLink`

const LinkForm = ({selectedLink, onResetSelect}: Props) => {
  const queryClient = useQueryClient()

  const {mutateAsync: submitLinkForm} = useMutation({
    mutationFn: async (sendvalues: ILinkFormValues) => {
      if (selectedLink) {
        await axios.put(UPDATE_LINK_URL, {...sendvalues, linkId: selectedLink.link_id})
        onResetSelect()
      } else {
        await axios.post(CREATE_LINK_URL, sendvalues)
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully created')
      queryClient.invalidateQueries(['linkList'])
      resetForm()
    },
    onError: (error: Error) => {
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: initLinkFormValues,
    onSubmit: async (values) => {
      try {
        console.log(values)
        toast.loading('Processing..')
        await submitLinkForm(values)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  useEffect(() => {
    resetForm()
    if (selectedLink) {
      formik.setValues({
        linkName: selectedLink.link_name,
        linkValue: selectedLink.link_value,
      })
    }
  }, [selectedLink])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Link Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onResetSelect}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='row row-cols-1'>
                {/* Link Name */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Link Name</label>

                    <input
                      {...formik.getFieldProps('linkName')}
                      placeholder='Link name'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                {/* Link Value */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Link Value</label>

                    <input
                      {...formik.getFieldProps('linkValue')}
                      placeholder='Link value'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>
              </div>
              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkForm
